export default __webpack_public_path__ + "static/media/bg.2fe6a383.webp";